import { createAsyncThunk } from '@reduxjs/toolkit';

import { entitiesActions } from '../slices/entitiesSlice';
import { uiActions } from '../slices/uiSlice';
import type { RootState } from '../store';

import { eventsService } from './_deps';

export const fetchEventsRange = createAsyncThunk<
  void,
  { from: string; to: string },
  { state: RootState }
>('events/fetchRange', async ({ from, to }, thunkApi) => {
  const { dispatch, getState } = thunkApi;

  try {
    const res = await eventsService.listEventsRange({ from, to });
    dispatch(entitiesActions.upsertEvents(res.items));
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Не удалось загрузить события';
    throw error;
  }
});
